/**
 * DebugConfig — single visible toggle surface for the /debug URL.
 *
 * /debug is the deterministic entry to the diagnostic-overlay map
 * (`debug-lobby`). Sibling to /lobby + /brawl + /pve + /abilitytest.
 *
 * On mount, main.tsx sets `window.forceDebug = true` so every overlay
 * that gates on it auto-enables: LatencyOverlay, NetTrafficOverlay,
 * NetobsPacketSparkline, DebugInfoOverlay, multiplayer diagnostics.
 *
 * Wiring:
 *   - main.tsx       → reads on /debug path mount; injects URL params
 *                      + reset wipe + sets window.forceDebug
 *   - DebugLobby.ts  → MAP_ID = 'debug-lobby'
 *
 * Class default: defaults to mage; ClassSwitcherTopBar honors `?class=X`.
 */

export const DEBUG_CONFIG = {
  resetOnLoad: true,
  defaultClass: 'mage' as const,
  // 2026-05-13: switched from 'full' (every dev panel on) to
  // 'debug-tools-only' (minimal chrome, gameplay runs, DJ controls what's
  // visible via the 🛠 DebugLauncher). The earlier `full` preset showed
  // ALL dev panels including hud + chat + microMenu + character card +
  // map banner — fighting for screen real estate with the diagnostic
  // tools the /debug surface is supposed to highlight.
  preset: 'debug-tools-only' as const,
  skipSplash: true,
  skipLogin: true,

  // The quick class switcher is default-OFF everywhere WITH NO opt-ins
  // (DJ 2026-07-11 — it carries the old class roster and awaits an
  // overhaul). Explicit ?classSwitcher=1 is the only way to show it.
} as const;
